import { motion } from "framer-motion";
import svgPaths from "./animation-icons";

export function AnimatedUploadIcon() {
  return (
    <div
      className="relative shrink-0 size-[140px]"
      data-name="버전 1 업로드 그래픽"
    >
      <div className="absolute bottom-[-5.11%] left-0 right-0 top-0">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 140 148"
        >
          <g id="ë²ì  1 ìë¡ë ê·¸ëí½">
            {/* Background shadows - grouped together */}
            <motion.g
              initial={{ opacity: 0, y: 10 }}
              animate={{
                opacity: 1,
                y: [0, -6, 0],
                x: [0, 1, 0],
              }}
              transition={{
                opacity: { duration: 0.8, delay: 0.2 },
                y: {
                  duration: 2.5,
                  delay: 2.0,
                  repeat: Infinity,
                  ease: "easeInOut",
                },
                x: {
                  duration: 3,
                  delay: 2.2,
                  repeat: Infinity,
                  ease: "easeInOut",
                },
              }}
            >
              <path
                d={svgPaths.p2f35a900}
                fill="var(--fill-0, #93C5FD)"
                id="Vector 54"
              />
              <path
                d={svgPaths.p37a29580}
                fill="var(--fill-0, #2563EB)"
                id="Vector 55"
              />
            </motion.g>

            {/* Main document with floating animation */}
            <motion.g
              filter="url(#filter0_dd_1_315)"
              id="Frame 2087329410"
              initial={{ opacity: 0, y: 15 }}
              animate={{
                opacity: 1,
                y: [0, -6, 0],
                x: [0, 1.5, 0],
              }}
              transition={{
                opacity: { duration: 0.8, delay: 0.6 },
                y: {
                  duration: 2,
                  delay: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                },
                x: {
                  duration: 2.8,
                  delay: 1.8,
                  repeat: Infinity,
                  ease: "easeInOut",
                },
              }}
            >
              <g id="Vector">
                <path d={svgPaths.pa462d48} fill="#BFDBFE" />
                <path d={svgPaths.p129c0180} fill="var(--fill-0, #3B82F6)" />
              </g>
            </motion.g>

            {/* Document lines with staggered animation */}
            <motion.g
              filter="url(#filter1_dd_1_315)"
              id="Vector 41"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
            >
              <path d={svgPaths.p1d9d4700} fill="var(--fill-0, #60A5FA)" />
            </motion.g>

            <motion.g
              filter="url(#filter2_dd_1_315)"
              id="Vector 56"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 1.2 }}
            >
              <path d={svgPaths.p247ea8f0} fill="var(--fill-0, #BFDBFE)" />
            </motion.g>

            <motion.g
              filter="url(#filter3_dd_1_315)"
              id="Vector 57"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 1.4 }}
            >
              <path d={svgPaths.p24402bd1} fill="var(--fill-0, #BFDBFE)" />
            </motion.g>
          </g>
          <defs>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="138.154"
              id="filter0_dd_1_315"
              width="107.5"
              x="23.5"
              y="9"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="4"
                result="effect1_dropShadow_1_315"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                mode="normal"
                result="effect1_dropShadow_1_315"
              />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="3"
                result="effect2_dropShadow_1_315"
              />
              <feOffset dy="10" />
              <feGaussianBlur stdDeviation="7.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="effect1_dropShadow_1_315"
                mode="normal"
                result="effect2_dropShadow_1_315"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow_1_315"
                mode="normal"
                result="shape"
              />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="47.2237"
              id="filter1_dd_1_315"
              width="73.0001"
              x="64"
              y="37.3882"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="4"
                result="effect1_dropShadow_1_315"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                mode="normal"
                result="effect1_dropShadow_1_315"
              />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="3"
                result="effect2_dropShadow_1_315"
              />
              <feOffset dy="10" />
              <feGaussianBlur stdDeviation="7.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="effect1_dropShadow_1_315"
                mode="normal"
                result="effect2_dropShadow_1_315"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow_1_315"
                mode="normal"
                result="shape"
              />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="47.2237"
              id="filter2_dd_1_315"
              width="73.0001"
              x="42"
              y="66.3882"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="4"
                result="effect1_dropShadow_1_315"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                mode="normal"
                result="effect1_dropShadow_1_315"
              />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="3"
                result="effect2_dropShadow_1_315"
              />
              <feOffset dy="10" />
              <feGaussianBlur stdDeviation="7.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="effect1_dropShadow_1_315"
                mode="normal"
                result="effect2_dropShadow_1_315"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow_1_315"
                mode="normal"
                result="shape"
              />
            </filter>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="47.2237"
              id="filter3_dd_1_315"
              width="73.0001"
              x="47"
              y="77.3882"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="4"
                result="effect1_dropShadow_1_315"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="3" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                mode="normal"
                result="effect1_dropShadow_1_315"
              />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feMorphology
                in="SourceAlpha"
                operator="erode"
                radius="3"
                result="effect2_dropShadow_1_315"
              />
              <feOffset dy="10" />
              <feGaussianBlur stdDeviation="7.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                in2="effect1_dropShadow_1_315"
                mode="normal"
                result="effect2_dropShadow_1_315"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow_1_315"
                mode="normal"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
}
